/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled, { css } from 'styled-components';
import Colors from 'constants/Colors';
import { FontWeight } from 'components/Text';
import { Breakpoints } from 'constants/Breakpoints';

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction:row;
  justify-content: space-between;
  align-items:center;
  margin-top: 20px;
  width: 100%;
  padding: 0px 20px 0px 0px;
`;

export const ButtonContent = styled.div`
  display:flex;
  flex-direction: row;
  justify-content: space-evenly;
  
  @media (max-width: ${Breakpoints.lg}) {  
    flex-wrap: wrap;
    padding-right: 10px;
    width: 100%;
  }
`;

export const Scrollbox = styled.div` 
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 500px;
  padding:10px 20px 10px 10px;
  
  ::-webkit-scrollbar{
    background:${Colors.WHITE};
    width:8px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${Colors.GRAY[3]};
    border-radius: 15px;
  }
  `;

export const Text = styled.text`
  color: ${Colors.GRAY[6]};
  font-weight: ${FontWeight.SemiBold};
  text-transform: uppercase;
  font-size: 16px;
  cursor: pointer;
`;

export const TableHeader = styled.div`
  display:flex;
  flex-direction:row;
  width: 100%;
  height:24px;
  background-color: red;
`;

export const TextArea = styled.textarea`
width:100%;
height: 120px;
padding:15px;
border:2px solid ${Colors.GRAY[3]};
border-radius:8px;
resize:none;
font-family: Courier, monospace;
font-weight: ${FontWeight.SemiBold};
color: ${Colors.GRAY[6]};
font-size:14px;
`;
